<template>
  <form-item
    v-if="isForm"
    :name="name"
    :prop="prop"
    :rules="rules"
    :label="label"
    :hasDesc="hasDesc"
    :descContent="getTransText(name,'desc',base)"
    >
    <el-input-number
      v-model.number="val"
      @input="onInput"
      class="form-item"
      :min="min"
      :max="max"
      :precision="precision"
      :disabled="$attrs.disabled"
      >
    </el-input-number>
  </form-item>
  <el-table-column
    v-else
    :label="label"
    align="center"
    width="80"
    >
    <template slot-scope="scope">
      <span v-text="scope.row[dataName]"></span>
    </template>
  </el-table-column>
</template>

<script>

import { getLabelText, getTransText } from '@/utils/i18n'

export default {
  name: 'number-field',
  props: {
    value: null,
    base: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      default: ''
    },
    hasDesc: {
      type: Boolean,
      default: false
    },
    data: {
      type: String
    },
    prop: {
      type: String
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 9999
    },
    precision: {
      type: Number,
      validator (val) {
        return val >= 0 && val === parseInt(val, 10)
      }
    },
    inputRules: {
      type: Array,
      default: () => {}
    },
    isForm: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      val: this.value,
      dataName: this.data || this.name
    }
  },
  computed: {
    rules () {
      if (this.inputRules) {
        return this.inputRules
      }
      return [{
        required: true,
        message: this.getTransText(this.name, 'error', this.base)
      }]
    },
    label: function () {
      return this.labelText ||
        this.getLabelText(this.base, this.name)
    }
  },
  methods: {
    getTransText,
    getLabelText,
    onInput () {
      this.$emit('input', this.val)
    }
  },
  watch: {
    value (newValue) {
      this.val = newValue
    }
  }
}
</script>
